export default __webpack_public_path__ + "resources/icons/d100-c17a.webp";